import {
  makeStyles,
  shorthands,
  tokens,
  typographyStyles,
} from '@fluentui/react-components';

export const useTableStyles = makeStyles({
  dataGridWrapper: {
    width: '100%',
    ...shorthands.padding('10px', '5px'),
    ...shorthands.borderRadius('5px'),
    ...shorthands.border('2px', 'solid', tokens.colorNeutralBackground1Pressed),
    '& thead th:nth-child(2)': {
      width: '280px',
    },
    '& thead th:nth-child(3)': {
      width: '130px',
    },
  },
  accountCheckbox: {
    '& thead th:nth-child(1)': {
      width: '40px',
    },
    '& thead th:nth-child(2)': {
      width: '280px',
    },
    '& thead th:nth-child(3)': {
      width: '130px',
    },
  },
  dataGridContainer: {
    maxHeight: '350px',
    overflowY: 'auto',
    '& .loading-goal': {
      height: '100px',
      display: 'flex',
      justifyContent: 'center',
    },
  },
  dataGrid: {
    width: '100%',
    marginTop: '15px',
  },
  mainConversionCheckbox: {
    width: '20px',
  },
  searchbox: {
    minWidth: '400px',
    marginLeft: '20px',
  },
  headerBar: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    ...shorthands.borderBottom('2px', 'solid', tokens.colorNeutralBackground1Pressed),
    paddingTop: '10px',
    paddingBottom: '15px',
    '& .show-select-control input[type="checkbox"]': {
      width: '100%',
      height: '100%',
    },
  },
  footer: {
    display: 'flex',
    ...shorthands.padding('10px', '10px'),
    '& .page-selector': {
      marginRight: '20px',
      maxWidth: 'max-content',
      '& label': {
        fontWeight: tokens.fontWeightRegular,
      },
    },
  },
  clearAllBtn: {
    width: '100px', // ui-next
    '& div': {
      justifyContent: 'center',
    },
  },
  headerTitle: {
    ...typographyStyles.caption1Strong,
    fontSize: tokens.fontSizeBase200,
  },
});
